import React from 'react';
import { INLINES } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import styles from './RichText.module.scss';
import { Link } from '../link/Link';

const RichText = ({ content }) => {
  const options = {
    renderNode: {
      [INLINES.HYPERLINK]: (node, children) => {
        const url = node.data.uri;
        const isExternalLink =
          url?.startsWith('http') ||
          url?.startsWith('https') ||
          !url?.startsWith('/');
        // // If the URL starts with 'http' or 'https', we assume it's an external link
        // and render it in a new tab.
        if (isExternalLink) {
          return (
            <a href={node.data.uri} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          );
        }

        // If the URL starts with '/', we assume it's an internal link
        // and render it using the <Link> component.
        else if (node.data.uri.startsWith('/')) {
          return <Link to={node.data.uri}>{children}</Link>;
        }
      },
    },
  };

  return (
    <div className={styles.richText}>
      {documentToReactComponents(content, options)}
    </div>
  );
};

export default RichText;
